"use client";

import { CarouselYearCards } from "@bumble/ui-kit";
const PLACEHOLDER_IMAGE = "/assets/placeholder-background.png";
export interface CarouselItemData {
  id?: string;
  title?: string | null;
  description?: string | null;
  image?: {
    url?: string | null;
    alt?: string | null;
  } | null;
}
export interface CarouselBlockData {
  title?: string | null;
  description?: string | null;
  scrollText?: string | null;
  items?: CarouselItemData[];
}
interface Props {
  data: CarouselBlockData;
}
export default function Carousel({
  data
}: Props) {
  const {
    title,
    description,
    scrollText,
    items = []
  } = data;
  const cards = items.map(item => ({
    title: item.title ?? "",
    description: item.description ?? "",
    type: "year" as const,
    image: {
      alt: item.image?.alt ?? "Placeholder image",
      src: item.image?.url || PLACEHOLDER_IMAGE
    }
  }));
  if (cards.length === 0) {
    return null;
  }
  return <div style={{
    padding: "20px 0"
  }}>
      <CarouselYearCards a11yScrollLeftText="Scroll left" a11yScrollRightText="Scroll right" cards={cards} description={description ?? ""} scrollText={scrollText ?? "Scroll to explore"} title={title ?? ""} />
    </div>;
}